export default __webpack_public_path__ + "static/media/DNo.26-2.444114c0.jpg";